import React from "react";

export const ToastContext = React.createContext(null);

export const ToastContextProvider = ({ children }) => {
    const [message, setMessage] = React.useState(undefined);
    const [severity, setSeverity] = React.useState(undefined);
    const [newTeamId, setNewTeamId] = React.useState(undefined);
    const [isPersonalMissions, setIsPersonalMissions] = React.useState(undefined);
    const [isTeamMissions, setIsTeamMissions] = React.useState(undefined);
    const [missionTeamId, setMissionTeamId] = React.useState(undefined);
    const [isToastTriggered, setIsToastTriggered] = React.useState(false);

    React.useEffect(() => {
        const timeId = setTimeout(() => {
            setIsToastTriggered(false);
            setMessage(undefined);
            setSeverity(undefined);
            setNewTeamId(undefined);
        }, 6000);
        return () => {
            clearTimeout(timeId);
        };
    }, [isToastTriggered, setIsToastTriggered]);

    const value = React.useMemo(
        () => ({
            message,
            severity,
            newTeamId,
            isToastTriggered,
            isPersonalMissions,
            isTeamMissions,
            missionTeamId,
            setNewTeamId,
            setIsToastTriggered,
            setMessage,
            setSeverity,
            setIsPersonalMissions,
            setIsTeamMissions,
            setMissionTeamId,
        }),
        [message, severity, isToastTriggered, setIsToastTriggered]
    );

    return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
};
